<template>
  <div class="supermarket">
    <!-- banner -->
    <div class="banner"></div>
    <!-- 创新券商品 -->
    <div class="store_tab">
      <div class="m">
        <div class="store_tab_tit">
          <div class="l">
            <h2>创新券服务专区</h2>
            <ul>
              <li
                :class="{active:cxqActive==='ServiceHotTypeCXQResearchDev'}"
                @click="changeCXQ('ServiceHotTypeCXQResearchDev')"
              >研究开发</li>
              <li
                :class="{active:cxqActive==='ServiceHotTypeCXQCheck'}"
                @click="changeCXQ('ServiceHotTypeCXQCheck')"
              >检验检测</li>
              <li
                :class="{active:cxqActive==='ServiceHotTypeCXQInstrument'}"
                @click="changeCXQ('ServiceHotTypeCXQInstrument')"
              >大型科学仪器共享</li>
            </ul>
          </div>
          <div class="r">
            <!-- 研究开发 -->
            <template v-if="cxqActive==='ServiceHotTypeCXQResearchDev'">
              <router-link
                to="/supermarket/goods_list?type=RangeServicesResearch&is_coupon=true"
                target="_blank"
              >
                更多
                <i class="el-icon-arrow-right"></i>
              </router-link>
            </template>
            <!-- 检验检测 -->
            <template v-else-if="cxqActive==='ServiceHotTypeCXQCheck'">
              <router-link
                to="/supermarket/goods_list?type=RangeServicesCheck&is_coupon=true"
                target="_blank"
              >
                更多
                <i class="el-icon-arrow-right"></i>
              </router-link>
            </template>
            <!-- 大型科学仪器共享 -->
            <template v-else-if="cxqActive==='ServiceHotTypeCXQInstrument'">
              <router-link
                to="/supermarket/goods_list?type=RangeServicesShare&is_coupon=true"
                target="_blank"
              >
                更多
                <i class="el-icon-arrow-right"></i>
              </router-link>
            </template>
          </div>
        </div>
        <cxqGoods :list="cxqList" v-if="cxqList.length" />
        <div class="no_data" v-else>
          <div>科技服务正在上线的路上哟~</div>
        </div>
      </div>
    </div>
    <!-- 非创新券商品 -->
    <div class="store_tab gary">
      <div class="m">
        <div class="store_tab_tit">
          <div class="l">
            <h2>科技服务</h2>
            <ul>
              <li
                :class="{active:active==='ServiceHotTypeResearchDev'}"
                @click="changeClassone('ServiceHotTypeResearchDev')"
              >研究开发</li>
              <li
                :class="{active:active==='ServiceHotTypeCheck'}"
                @click="changeClassone('ServiceHotTypeCheck')"
              >检验检测</li>
              <li
                :class="{active:active==='ServiceHotTypeInstrument'}"
                @click="changeClassone('ServiceHotTypeInstrument')"
              >大型科学仪器共享</li>
              <li
                :class="{active:active==='ServiceHotTypeIRP' && classTwo==='RangeServicesOtherIPR'}"
                @click="changeClassone('ServiceHotTypeIRP','RangeServicesOtherIPR')"
              >知识产权</li>
              <li
                :class="{active:active==='ServiceHotTypeOther'&& classTwo==='RangeServicesOtherOther' }"
                @click="changeClassone('ServiceHotTypeOther','RangeServicesOtherOther')"
              >其他</li>
            </ul>
          </div>
          <div class="r">
            <!-- 研究开发 -->
            <template v-if="active==='ServiceHotTypeResearchDev'">
              <router-link
                :to="`/supermarket/goods_list?type=RangeServicesResearch`"
                target="_blank"
              >
                更多
                <i class="el-icon-arrow-right"></i>
              </router-link>
            </template>
            <!-- 检验检测 -->
            <template v-else-if="active==='ServiceHotTypeCheck'">
              <router-link :to="`/supermarket/goods_list?type=RangeServicesCheck`" target="_blank">
                更多
                <i class="el-icon-arrow-right"></i>
              </router-link>
            </template>
            <!-- 大型科学仪器共享 -->
            <template v-else-if="active==='ServiceHotTypeInstrument'">
              <router-link :to="`/supermarket/goods_list?type=RangeServicesShare`" target="_blank">
                更多
                <i class="el-icon-arrow-right"></i>
              </router-link>
            </template>
            <!-- 知识产权 -->
            <template v-else-if="active==='ServiceHotTypeIRP'">
              <router-link
                :to="`/supermarket/goods_list?type=RangeServicesOther&class_two=${classTwo}`"
                target="_blank"
              >
                更多
                <i class="el-icon-arrow-right"></i>
              </router-link>
            </template>
            <!-- 其他 -->
            <template v-else-if="active==='ServiceHotTypeOther'">
              <router-link
                :to="`/supermarket/goods_list?type=RangeServicesOther&class_two=${classTwo}`"
                target="_blank"
              >
                更多
                <i class="el-icon-arrow-right"></i>
              </router-link>
            </template>
          </div>
        </div>
        <normalGoods :list="list" v-if="list.length" />
        <div class="no_data" v-else>
          <div>科技服务正在上线的路上哟~</div>
        </div>
      </div>
    </div>
    <!-- 店铺 -->
    <div class="shop">
      <div class="m">
        <div class="shop_tit">
          <div class="l">
            <h2>优选店铺</h2>
            <ul>
              <li
                :class="{active:shopActive==='ShopHotTypeCloudsupercomputing'}"
                @click="changeShop('ShopHotTypeCloudsupercomputing')"
              >云+超算</li>
              <li
                :class="{active:shopActive==='ShopHotTypeInspectionAndDetection'}"
                @click="changeShop('ShopHotTypeInspectionAndDetection')"
              >检验检测</li>
              <li
                :class="{active:shopActive==='ShopHotTypeInstitutionsOfHigherlearning'}"
                @click="changeShop('ShopHotTypeInstitutionsOfHigherlearning')"
              >高等院校</li>
              <li
                :class="{active:shopActive==='ShopHotTypeInstrumentSharing'}"
                @click="changeShop('ShopHotTypeInstrumentSharing')"
              >仪器共享</li>
            </ul>
          </div>
          <div class="r">
            <router-link :to="'/supermarket/store_list'">
              更多
              <i class="el-icon-arrow-right"></i>
            </router-link>
          </div>
        </div>
        <shop_list :list="shopList" />
      </div>
    </div>
  </div>
</template>

<script>
import hotLabels from "@/components/mall/hot_labels.vue";
import shop_list from "@/components/list/mall/shop/list.vue";
import cxqGoods from "@/components/list/mall/cxqGoods/list.vue";
import normalGoods from "@/components/list/mall/normalGoods/list.vue";
export default {
  components: {
    hotLabels,
    shop_list,
    cxqGoods,
    normalGoods
  },
  data() {
    return {
      cxqActive: "ServiceHotTypeCXQResearchDev", //默认研究开发服务(创新券)
      active: "ServiceHotTypeResearchDev", //默认研究开发服务（非创新券）
       shopActive:'ShopHotTypeCloudsupercomputing',//店铺
      classTwo: "", //知识产权和其它
      shopList: [], //店铺列表
      cxqList: [], //创新券商品列表
      list: [] //普通商品
    };
  },
  created() {
    this.getShopList(); //店铺列表改版
    this.changeCXQ("ServiceHotTypeCXQResearchDev"); //根据分类获取创新券商品改版
    this.changeClassone("ServiceHotTypeResearchDev"); //根据分类获取非创新券商品改版
  },
  methods: {
    // 创新券商品更换分类
    changeCXQ(classone) {
      this.cxqActive = classone;
      this.getCXQData();
    },
    // 根据分类获取创新券商品
    getCXQData() {
      let params = {
        pageSize: 6,
        pageNo: 0,
        is_star: true,
        star_service_hot_type: this.cxqActive
      };
      this.api.getHotServicesHZ(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        this.cxqList = res.obj.list;
      });
    },
    // 非创新券商品更换分类
    changeClassone(classone, classTwo = "") {
      this.active = classone;
      this.classTwo = classTwo;
      this.getData();
    },
    // 根据分类获取非创新券商品
    getData() {
      let params = {
        pageSize: 8,
        pageNo: 0,
        is_star: true,
        star_service_hot_type: this.active
      };
      this.api.getHotServicesHZ(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        this.list = res.obj.list;
      });
    },
    /** 获取数据字段*/
    getDictionaries(typeCode) {
      let params = {
        pageNo: 0,
        pageSize: 3,
        typeCode: typeCode
      };
      this.api.getDictionaries(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        res.obj.list.forEach(ele => {
          if (ele.code === "RangeServicesResearch") {
            this.info_data1.params.class_ones = ele.id;
          }
          if (ele.code === "RangeServicesCheck") {
            this.info_data2.params.class_ones = ele.id;
          }
          if (ele.code === "RangeServicesShare") {
            this.info_data3.params.class_ones = ele.id;
          }
        });
      });
    },
// 非创新券商品更换分类
    changeShop(shopActive) {
      this.shopActive = shopActive;
      this.getShopList();
    },
    /*获取店铺列表*/

    getShopList() {
      let params = {
        pageSize: 6,
        pageNo: 0,
        type: "InstituteTypeShop",
        is_star: true,
         star_shop_hot_type:this.shopActive
      };
      this.api.getHotInstituteHZ(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        this.shopList = res.obj.list;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.supermarket {
  .banner {
    height: 400px;
    background: #fde0b8 url(~@/assets/img/supermarker/banner2.png) no-repeat
      center;
  }
  .store_tab {
    background: #fff;
    padding: 30px 0 45px;
    .store_tab_tit {
      display: flex;
      justify-content: space-between;
      height: 81px;
      align-items: center;
      .l {
        display: flex;
        align-items: center;
        h2 {
          font-size: 22px;
          font-weight: bold;
          color: #4c5062;
        }
        ul {
          display: flex;
          li {
            font-size: 16px;
            font-weight: 500;
            color: #4c5062;
            margin-left: 40px;
            cursor: pointer;
          }
          li.active {
            color: #ff743c;
          }
        }
      }
      .r {
        a {
          font-size: 14px;
          color: #4c5062;
          i {
            color: #b9bcca;
          }
        }
      }
    }
    .no_data {
      height: 358px;
      padding: 70px 0;
      background: #fff url(~@/assets/img/common/no_content.png) no-repeat center;
      box-sizing: border-box;
      font-size: 14px;
      color: #999;
      display: flex;
      justify-content: center;
      align-items: flex-end;
    }
  }
  .store_tab.gary {
    background: #f0f2f5;
  }
  .shop {
    background: #f0f2f5;
    padding: 30px 0 60px;
    .m {
      .shop_tit {
        display: flex;
        justify-content: space-between;
        height: 81px;
        align-items: center;
        .l {
          display: flex;
          h2 {
            font-size: 22px;
            font-weight: bold;
            color: #4c5062;
          }
          ul {
            display: flex;
            li {
              font-size: 16px;
              font-weight: 500;
              color: #4c5062;
              margin-left: 40px;
              cursor: pointer;
            }
            li.active {
              color: #ff743c;
            }
          }
        }
        .r {
          a {
            font-size: 14px;
            color: #4c5062;
            i {
              color: #b9bcca;
            }
          }
        }
      }
    }
  }
}
</style>
